import { useCallback } from 'react';
import { useCreate, useGo } from '@refinedev/core';
import { Button } from '@/components/ui/button';
import {
  FormStickyActions,
  FormSpacer,
  FormHeader,
} from '@/components/forms';
import type { BroadcastCreatePayload } from './types';
import { BroadcastFormLayout } from './components';
import { useBroadcastForm } from './hooks';

export function BroadcastsCreate() {
  const go = useGo();
  const createMutation = useCreate<BroadcastCreatePayload>();
  const isPending = createMutation.mutation?.isPending ?? false;

  const form = useBroadcastForm();

  const handleGoBack = useCallback(() => go({ to: '/broadcasts' }), [go]);

  const handleSubmit = useCallback((e: React.FormEvent) => {
    e.preventDefault();
    const payloadData = form.buildSubmitPayload();
    createMutation.mutate(
      { resource: 'broadcasts', values: payloadData },
      { onSuccess: () => go({ to: '/broadcasts' }) },
    );
  }, [form, createMutation, go]);

  return (
    <div className="space-y-6">
      <FormHeader
        title="Новая рассылка"
        description="Создание массового сообщения с поддержкой мультиязычности"
        onBack={handleGoBack}
        sticky
      />

      <BroadcastFormLayout
        formId="broadcast-create-form"
        form={form}
        isPending={isPending}
        onSubmit={handleSubmit}
      />

      <FormSpacer />

      <FormStickyActions>
        <Button type="submit" form="broadcast-create-form" disabled={isPending || !form.hasChannels}>
          {isPending ? 'Создание...' : 'Создать рассылку'}
        </Button>
        <Button type="button" variant="outline" onClick={form.handleOpenPreview} disabled={isPending || !form.previewLanguage}>
          Предпросмотр
        </Button>
        <Button type="button" variant="outline" onClick={handleGoBack} disabled={isPending}>
          Отмена
        </Button>
      </FormStickyActions>
    </div>
  );
}
